import Loadercomp from '../Loadercomp';
import ViewComponent from './View';

const 
Layoutviewpage = ({
    title,
    fields,
    loading,
    initialValues,
    onCancel,
    children,
     }) => {
        
    return (
      loading == true ? <div><Loadercomp size={100} /></div> : <div>
      <div className="bg-white shadow-md rounded-lg">

      <div className="pl-8 pt-5">
     <h2 className="font-inter text-2xl text-[#333843] font-semibold flex justify-between items-center">
      <span>{title}</span>
      <button onClick={onCancel}><span className="mr-[46px]" >X</span></button>  
       </h2>
      </div>

           {loading && (
          <div>
              <Loadercomp size={100} />

          </div>
      )} 
      <div className="container-fluid pb-4 pt-3 px-4 bg-white">
          
          <ViewComponent
           fields={fields}
           initialValues={initialValues}
          />
          </div>
          <div className="mt-4">{children}</div>
      </div>
  </div> 
    )
}
export default Layoutviewpage;